export default "__VITE_ASSET__Btbo6k9A__"